module.exports = {
  text: `Разумные, ядовитые лягушки, которые живут на деревьях. Боги и вправду нас ненавидят.`,
  author: `Воло`,
}
